import type { Dispatch, SetStateAction } from 'react';
import { useRef } from 'react';

import useUserAdminAllSurveysQuery from 'src/components/userAdmin/hooks/useUserAdminAllSurveysQuery';
import { useUserList } from 'src/components/userAdmin/hooks/useUserList';
import { useUserAdmin } from 'src/components/userAdmin/UserAdminContext';

export interface useUserListAddModalProps {
  isOpen: boolean;
  onClose: () => void;
  setEmailValidation: Dispatch<SetStateAction<string | undefined>>;
}

export function useUserListAddModal({
  isOpen,
  onClose,
  setEmailValidation,
}: useUserListAddModalProps) {
  const { goToDetail } = useUserList();
  const { searchString } = useUserAdmin();
  const enable = useRef(false);
  const { refetch } = useUserAdminAllSurveysQuery(
    // Manually control if enpoint is enabled to reduce queries
    isOpen && enable.current,
    searchString,
  );

  const handleAddUser = (email: string) => {
    enable.current = true;
    refetch()
      .then(({ data, status }) => {
        if (!isOpen || status === 'error') {
          // Early return if modal was closed or status is error
          return;
        }
        if (data && data.count > 1) {
          onClose();
        }
        const { users } = data || {};
        const user = users?.[0];
        const userId = user?.id ?? 0;
        const params =
          userId && user?.role
            ? undefined
            : {
                searchAllSurveys: true,
                newUserEmail: user?.email || email || '',
              };
        goToDetail(userId, params);
        setEmailValidation('');
        onClose();
      })
      .catch((error) => error);
  };
  return { handleAddUser };
}
